// src/utils/urlUtils.js
export const encodeBrandId = (brandId) => {
    // Add a salt and encode to make it more random-looking
    return btoa(`brand_${brandId}_${Date.now()}`);
  };
  
  export const decodeBrandId = (encodedId) => {
    try {
      const decoded = atob(encodedId);
      // Extract the actual brand ID from the decoded string
      const match = decoded.match(/brand_([^_]+)_/);
      return match ? match[1] : null;
    } catch (e) {
      console.error("Error decoding brand ID:", e);
      return null;
    }
  };